








































































































































































































































































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { mapGetters } from "vuex";
import { Providers, ProviderArr } from "@/data/BusinessTypes";
import DepartList, { DepartArray } from "@/data/DepartList";
import version from "@/version";

@Component({
    ...mapGetters(["accountBook"]),
})
export default class InvoiceAdd extends Vue {
    @Prop({ type: Object, default: false })
    invoiceData?: any;

    end: Date = new Date();
    addOrmodify: boolean = true;
    dateTime: string = "";

    //图片
    showImg: boolean = false
    downImg() {
        // 下载
        this.$utils.sendToElectron("download", `${Vue.axios.defaults.baseURL}export/pdf/invoice/print?id=${this.invoiceData.id}&version=${version}&token=${this.$store.state.account.token}`)
    }
    // 删除图片
    delImg() {
        this.$msgbox({
            message: "是否确认删除图片？",
            title: "温馨提示",
            confirmButtonText: "确定",
            showCancelButton: true,
        }).then((action: any) => {
            if (action === "confirm") {
                Vue.axios
                    .post(`invoice/del/image?id=${this.invoiceData.id}`)
                    .then((res) => {
                        this.showImg = false;
                        this.invoiceData.url = null;
                    });
            }
        });
    }

    get pickerOptions() {
        return {
            disabledDate: (time: Date) => {
                return time.getTime() >= this.end.getTime();
            },
        };
    }

    showinvTableBody: boolean = false;
    businessTypeArray = ProviderArr;
    departmentArray: any = [];
    arrydepart = DepartArray
    departmentList = DepartList;
    businessTypeList = Providers;
    newInvoiceDetails: any = [];
    customerList: Assist.AssistAccount[] = [];
    buttonText: string = "";
    get priceTaxMoneyAmounts() {
        if (this.invoiceData) {
            return (
                Number(this.invoiceData.moneyAmounts) +
                Number(this.invoiceData.taxAmounts)
            );
        }
    }
    get dimAccountType() {
        return +this.invoiceData.isProviderOrCustomer === 0
            ? ["客户", "dimCustomerList"]
            : ["供应商", "dimProviderList"];
    }

    get isProvider() {
        return +this.invoiceData.isProviderOrCustomer === 0;
    }

    created() {
        this.init();
        this.departmentArray = this.arrydepart
    }
    // 初始化数据
    defaultDate: Date = new Date();
    init() {
        let endPeriod: Date = new Date(
            this.$store.state.accountBook.currentPeriod.substring(0, 4) +
            "-" +
            this.$store.state.accountBook.currentPeriod.substring(4)
        );
        let currentPeriod: string = this.$store.state.accountBook.currentPeriod.toString();
        this.end = this.$utils.dateAdd(endPeriod, "m", 1);
        //初始时间格式
        if (this.invoiceData) {
            if (this.invoiceData.invoiceDate === null) {
                //新增默认为空
                this.dateTime = "";
                this.defaultDate = endPeriod;
                this.addOrmodify = true;
                this.buttonText = "新增并保存";
                if (!this.isProvider) this.invoiceData.status = "0";
            } else {
                this.addOrmodify = false;
                this.showinvTableBody = true;
                this.buttonText = "保存";
                this.dateTime = this.handlePeriod(this.invoiceData.invoiceDate);
            }
            //创建表格数据
            for (let i = 0; i < this.invoiceData.invoiceDetails.length; i++) {
                this.newInvoiceDetails.push(this.invoiceData.invoiceDetails[i]);
            }
            if (this.invoiceData.invoiceDetails.length < 6) {
                let num = 6 - this.invoiceData.invoiceDetails.length;
                for (let i = 0; i < num; i++) {
                    this.newInvoiceDetails.push({
                        id: null,
                        accountBookId: this.$store.state.accountBook.id,
                        productName: null,
                        number: null,
                        unitPrice: null,
                        moneyAmount: null,
                        taxRate: null,
                        taxAmount: null,
                        specification: null,
                        rowNumber: null,
                        remark: null,
                        unit: null,
                    });
                }
            }
        }
        //获取customerList
        this.getCustomerList();
        this.getProduct()
    }

    handleParam() {
        let num = this.newInvoiceDetails.length;
        if (this.invoiceData) this.invoiceData.invoiceDetails = [];
        for (let i = 0; i < num; i++) {
            if (this.newInvoiceDetails[i].productName !== null) {
                if (this.invoiceData)
                    this.invoiceData.invoiceDetails.push(
                        this.newInvoiceDetails[i]
                    );
            }
        }
    }

    isNull(text: string | null | undefined | number) {
        if (text === null || text === undefined || text === "" || +text === 0) return true;
        return false;
    }
    isTaxNull(text: string | null | undefined | number) {
        if (text === null || text === undefined || text === "") return true;
        return false;
    }

    isTaxAmount(text: string | null | undefined) {
        if (
            text === null ||
            text === undefined ||
            text === "" ||
            text === "0.00"
        )
            return true;
        return false;
    }

    rowNotNull(row: any) {
        if (
            !this.isNull(row.productName) ||
            !this.isNull(row.moneyAmount) ||
            !this.isNull(row.taxRate) ||
            !this.isTaxAmount(row.taxAmount)
        ) {
            return true;
        }
        return false;
    }

    addOrUpdateInvoice() {
        let url;
        if (this.invoiceData.id !== null) {
            url = "invoice/update";
        } else {
            url = "invoice/create";
        }

        let flag = false;
        for (let i = 0; i < this.newInvoiceDetails.length; i++) {
            let cur = this.newInvoiceDetails[i];
            if (this.rowNotNull(cur)) {
                if (
                    this.isNull(cur.productName) ||
                    this.isNull(cur.moneyAmount) || this.isTaxNull(cur.taxRate) || this.isTaxNull(cur.taxAmount)
                ) {
                    flag = true;
                    break;
                }
            }
        }

        if (this.invoiceData) {
            this.invoiceData.priceTaxMoneyAmounts = this.priceTaxMoneyAmounts;
            if (this.invoiceData.taxAmounts) {
                let value = this.invoiceData.taxAmounts;
                let num: any = Math.round(parseFloat(value) * 100) / 100;
                let xsd = value.toString().split(".");
                if (xsd.length == 1) {
                    num = num.toString() + ".00";
                }
                if (xsd.length > 1) {
                    if (xsd[1].length < 2) {
                        num = num.toString() + "0";
                    }
                }
                this.invoiceData.taxAmounts = num;
            }
        }
        if (flag) {
            this.$message({
                message: "亲,明细中只有规格型号和单位可以为空",
                type: "warning",
            });
        } else {
            this.handleParam();

            Vue.axios.post(url, this.invoiceData).then((res) => {
                if (this.invoiceData.id !== null) {
                    this.$emit("success", false);
                } else {
                    this.invoiceData.id = null;
                    this.invoiceData.invoiceNo = null;
                    this.invoiceData.invoiceDate = null;
                    this.invoiceData.invoiceType = "1";
                    this.invoiceData.status = "0";
                    this.invoiceData.createType = "0";
                    this.invoiceData.remark = null;
                    this.invoiceData.provider = null;
                    this.invoiceData.customer = null;
                    this.invoiceData.bankNo = null;
                    this.invoiceData.moneyAmounts = null;
                    this.invoiceData.taxAmounts = null;
                    this.invoiceData.department = null;
                    this.invoiceData.taxCode = null;
                    this.invoiceData.invoiceDetails = [];
                    this.newInvoiceDetails = [];
                    this.init();
                    this.$emit("success", true);
                }
            });
        }
    }

    cancel() {
        this.$emit("success", false);
    }
    // 只能输入数字
    returnNum(e: any, index: number) {
        let keycodes = [
            8,
            9,
            12,
            13,
            32,
            37,
            38,
            39,
            40,
            48,
            49,
            50,
            51,
            52,
            53,
            54,
            55,
            56,
            57,
            96,
            97,
            98,
            99,
            100,
            101,
            102,
            103,
            104,
            105,
            109,
            110,
            187,
            189,
            190,
        ];
        if (keycodes.indexOf(e.keyCode) == -1) {
            e.preventDefault();
            return;
        }

        let inputs: any = document.querySelectorAll(
            "#invTotal .invoince_money"
        );
        if (e.keyCode == 13) {
            e.preventDefault();
            if (index !== 0) {
                inputs[0].focus();
            } else {
                inputs[1].focus();
            }
        }
    }
    changeDate(val: any) {
        if (val !== "") {
            if (this.invoiceData)
                this.invoiceData.invoiceDate = this.$utils.simpleDateFormat(
                    val,
                    "d"
                );
        }
    }
    modifyNumberOrUnitPrice(el: any, data: any, name: string) {
        if (name) {
            data[name] = (el.target.value).replace(/,/g, "");
        }
        // console.log(data.number, data.unitPrice, !this.isNull(data.number) && !this.isNull(data.unitPrice))
        if (!this.isNull(data.number) && !this.isNull(data.unitPrice))
            data.moneyAmount = this.returnFloat(+(data.number.replace(/,/g, "")) * +(data.unitPrice.replace(/,/g, "")));
        if (data.taxRate !== null) {
            data.taxAmount = this.returnFloat(
                (+(data.moneyAmount.toString().replace(/,/g, "")) * +data.taxRate) / 100
            );
        }
        this.totalMoneyAmounts();
        this.totalTaxAmounts();
    }
    modifyTaxRate(el: any, data: any, name: string) {
        if (name === "taxAmount") {
            data[name] = el.target.value;
        } else {
            data.taxRate = el.target.value.replace(/%/g, "");
            this.taxRateCopy = el.target.value.replace(/%/g, "");
        }
        if (data.taxRate !== null && name !== "taxAmount") {
            data.taxAmount = this.returnFloat(
                (data.moneyAmount * data.taxRate) / 100
            );
        }
        this.totalTaxAmounts();
    }
    // 价税合计
    totalMoneyAmounts() {
        let total = 0;
        for (let i = 0; i < this.newInvoiceDetails.length; i++) {
            if (this.newInvoiceDetails[i].moneyAmount !== null) {
                total += +(this.newInvoiceDetails[i].moneyAmount.toString().replace(/,/g, "")) * 100;
            }
        }
        this.invoiceData.moneyAmounts = total / 100;
    }
    // 税额
    totalTaxAmounts() {
        let total = 0;
        for (let i = 0; i < this.newInvoiceDetails.length; i++) {
            if (this.newInvoiceDetails[i].taxAmount !== null) {
                console.log(this.newInvoiceDetails[i].taxAmount)
                let taxAmount = this.newInvoiceDetails[i].taxAmount
                let tax = (taxAmount.toString()).replace(/,/g, "")
                total += +(tax) * 100;
            }
        }
        this.invoiceData.taxAmounts = total / 100;
    }
    changeValue(el: any, name: string) {
        this.invoiceData[name] = el.target.value.replace(/,/g, "");
    }
    handlePeriod(val: string) {
        return `${val.substring(0, 4)}-${val.substring(4, 6)}-${val.substring(
            6,
            8
        )}`;
    }
    // 获取customerList
    getCustomerList() {
        Vue.axios
            .post(`dim/account/find`, {
                accountBookId: this.$store.state.accountBook.id,
                dimAccountType: this.dimAccountType[0],
            })
            .then((res) => {
                this.customerList = res.data[this.dimAccountType[1]];
            });
    }

    querySearchAsync(queryString: string, cb: any) {
        let restaurants = [];
        for (var i = 0; i < this.customerList.length; i++) {
            restaurants.push({ value: this.customerList[i].name });
        }
        var results = queryString
            ? restaurants.filter(this.createStateFilter(queryString))
            : restaurants;
        cb(results);
    }

    createStateFilter(queryString: any) {
        return (state: any) => {
            return (
                state.value.toLowerCase().indexOf(queryString.toLowerCase()) !=
                -1
            );
        };
    }
    productList = []
    queryAsync(queryString: string, cb: any) {
        let restaurants = [];
        for (var i = 0; i < this.productList.length; i++) {
            restaurants.push({ value: this.productList[i] });
        }
        var results = queryString
            ? restaurants.filter(this.createFilter(queryString))
            : restaurants;
        cb(results);
    }

    createFilter(queryString: any) {
        return (state: any) => {
            return (
                state.value.toLowerCase().indexOf(queryString.toLowerCase()) !=
                -1
            );
        };
    }
    getProduct() {
        Vue.axios
            .get(`invoice/product/name?accountBookId=${this.$store.state.accountBook.id}`)
            .then((res) => {
                this.productList = res.data
            });
    }
    // 删除发票
    delInvoice() {
        this.$msgbox({
            message: "是否确认删除发票？",
            title: "温馨提示",
            confirmButtonText: "确定",
            showCancelButton: true,
        }).then((action: any) => {
            if (action === "confirm") {
                Vue.axios
                    .post(`invoice/del?id=${this.invoiceData.id}`)
                    .then((res) => {
                        this.$emit("success", false);
                    });
            }
        });
    }
    //新增行  删除行
    addRow(index: number) {
        let templateData = {
            id: null,
            accountBookId: this.$store.state.accountBook.id,
            productName: null,
            number: null,
            unitPrice: null,
            moneyAmount: null,
            taxRate: null,
            taxAmount: null,
            specification: null,
            rowNumber: null,
            remark: null,
            unit: null,
        };
        if (index === 0) {
            this.newInvoiceDetails.unshift(templateData);
        } else {
            this.newInvoiceDetails.splice(index - 1, 0, templateData);
        }
    }
    delRow(index: number) {
        this.newInvoiceDetails.splice(index, 1);
        this.totalMoneyAmounts();
        this.totalTaxAmounts();
        if (this.newInvoiceDetails.length === 5) {
            this.newInvoiceDetails.push({
                id: null,
                accountBookId: this.$store.state.accountBook.id,
                productName: null,
                number: null,
                unitPrice: null,
                moneyAmount: null,
                taxRate: null,
                taxAmount: null,
                specification: null,
                rowNumber: null,
                remark: null,
                unit: null,
            });
        }
    }
    //保留2位小数
    returnFloat(value: any) {
        let num: any = Math.round(parseFloat(value) * 100) / 100;
        let xsd = value.toString().split(".");
        if (xsd.length == 1) {
            num = num.toString() + ".00";
            return num;
        }
        if (xsd.length > 1) {
            if (xsd[1].length < 2) {
                num = num.toString() + "0";
            }
            return num;
        }
    }
    taxRateCopy: string =
        this.$store.state.accountBook.addtax === "小规模纳税人" ? "1" : "13";
    handleSelect(data: Invoice.InvoiceDetails, index: number) {
        if (index > 0) {
            if (
                this.newInvoiceDetails[index - 1].taxRate != null &&
                this.newInvoiceDetails[index - 1].taxRate != ""
            ) {
                data.taxRate = this.newInvoiceDetails[index - 1].taxRate;
            } else {
                data.taxRate = this.taxRateCopy;
            }
        } else {
            data.taxRate = this.taxRateCopy;
        }
        // if(this.$store.state.accountBook.addtax === "小规模纳税人") {
        data.taxRate = this.taxRateCopy;
        // }else{
        //     data.taxRate = this.taxRateCopy;
        // }
    }
    changeDepartment(val: Invoice.AddInvoice) {
        this.invoiceData.department = val;
    }
    changeBusinessType(val: Invoice.AddInvoice) {
        this.invoiceData.businessType = val;
    }
    //键盘
    toNext(name: any) {
        (<any>this.$refs[name]).focus();
    }

    // 预览图片
    previewImage() {
        (<any>this.$refs.image).clickHandler();
    }
    @Prop()
    period!: string;
    async uploadFile(e: any) {
        const file = e.target.files[0];
        if (file) {
            let data = new FormData();
            data.append("file", file);
            data.append("id", this.invoiceData.id);

            if (file.size <= 2097152) {
                try {
                    const res = await Vue.axios.post(`invoice/upload/image`, data);
                    if (res.data.success) {
                        this.invoiceData.url = res.data.data.url;
                    }
                    this.$notify({
                        type: res.data.success ? "success" : "error",
                        message: res.data.message,
                        title: "温馨提示"
                    });
                } catch(e) {
                    this.$notify({
                        type: "error",
                        message: `${file.name}`,
                        title: "上传失败, 请稍候重试"
                    });
                } finally {
                    const input: any = document.querySelector(".image-uploader");
                    input.value = null;
                }
            } else {
                this.$notify({
                    type: "warning",
                    message: `${file.name}`,
                    title: "文件大于 2M，请压缩图片后再上传"
                });
            }
        }
    }
}
